import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['item', 'content', 'trigger'];
	static values = {
		group: { type: Boolean, default: true },
	};
	connect() {
		this.itemTargets.forEach((item) => {
			if (!item.classList.contains('is-open')) {
				const itemElement = item.querySelector('[data-accordion-target="content"]');
			}
		});
	}
	collapse(event) {
		const triggerElement = event.currentTarget;
		const itemElement = triggerElement.closest('[data-accordion-target="item"]');
		const contentElement = itemElement.querySelector('[data-accordion-target="content"]');

		if (triggerElement.getAttribute('aria-expanded') === 'true' || itemElement.classList.contains('is-open')) {
			triggerElement.setAttribute('aria-expanded', 'false');
			itemElement.classList.remove('is-open');
		} else {
			triggerElement.setAttribute('aria-expanded', 'true');
			itemElement.classList.add('is-open');
			if (this.groupValue === true) {
				this.collapseOthers(itemElement);
			}
		}
	}
	collapseOthers(element) {
		const nodes = this.getSiblings(element);
		nodes.forEach((item) => {
			item.classList.remove('is-open');
			// item.querySelector('[data-accordion-target="content"]').hidden = true;
			const siblingsTrigger = item.querySelector('[data-accordion-target="trigger"]');
			if (siblingsTrigger) {
				siblingsTrigger.setAttribute('aria-expanded', 'false');
			}
		});
	}
	getSiblings(element) {
		return this.itemTargets.filter((item) => item != element);
	}
}
